export default __webpack_public_path__ + "static/media/BookSearch.941565de.png";